import React from 'react';

import { List } from './List';
import { Edit } from './Edit';

export const attractionsSampleRoutes = {
  path: '/attractionsSample',
  children: [
    {
      path: '',
      element: <List />,
    },
    {
      path: ':id/edit',
      element: <Edit slug='/attractionsSample' />,
    },
    {
      path: 'add',
      element: <Edit slug='/attractionsSample' />,
    },
  ],
};
